import React from 'react';
export default function Form ({
  buttonClass,
  handleSubmit,
  children,
  ...props
}) {
  return (
    <form onSubmit={handleSubmit} {...props}>
      {children}
      <button className={`btn ${buttonClass || ''}`} type='submit'>
        Submit
      </button>
    </form>
  )
}
